module.exports = __webpack_public_path__ + "media/images/common/loading-1cf0dd80c62a15bc9235e7e10d2447c2.png";